// @flow strict

import * as React from 'react';

import styles from './DottedUnderline.css';

type Props = {|
  children: React.Node,
|};

const DottedUnderline = (props: Props) => (
  <span className={styles.dottedUnderlineSpan}>
    <u>{props.children}</u>
  </span>
);

export default DottedUnderline;
